/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CollectionJobSubject = core.serialization.object({
    resource: core.serialization.string(),
    params: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    query: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
